import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Material and other packages
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { TranslateUniversalLoader } from '../../translate-universal';


// Pipes
import { CurrencySpacePipe } from './pipes/currency-space.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { ThemeSourcePipe } from './pipes/theme-source.pipe';

// Top Banners
import { TopBarComponent } from './top-bar/top-bar.component';

import { SharedRoutingModule } from './shared-routing.module';

// Swiperjs
import { register } from 'swiper/element/bundle';
import { TippingFormComponent } from './tipping-form/tipping-form.component';
import { VoucherFormComponent } from './voucher-form/voucher-form.component';
import { LoaderOverlayComponent } from './loader-overlay/loader-overlay.component';
import { PaymentOptionsSheetComponent } from './payment-options-sheet/payment-options-sheet';
import { CommentSheetComponent } from './comment-sheet/comment-sheet.component';
import { CartLineItemComponent } from './cart-line-item/cart-line-item.component';
import { ModifierComponent } from './modifier/modifier.component';
import { OrderListComponent } from './order-list/order-list.component';
import { ComboGuideBlockComponent } from './combo-guide-block/combo-guide-block.component';
import { ItemComponent } from './item/item.component';
import { ItemVariantsSheetComponent } from './item-variants-sheet/item-variants-sheet.component';

register();



@NgModule({
  declarations: [
    FilterPipe,
    CurrencySpacePipe,
    TopBarComponent,
    ThemeSourcePipe,
    TippingFormComponent,
    VoucherFormComponent,
    PaymentOptionsSheetComponent,
    LoaderOverlayComponent,
    CommentSheetComponent,
    CartLineItemComponent,
    ModifierComponent,
    OrderListComponent,
    ComboGuideBlockComponent,
    ItemComponent,
    ItemVariantsSheetComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    LazyLoadImageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateUniversalLoader
      }
    }),
  ],
  exports: [
    CommonModule,
    SharedRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatBottomSheetModule,
    MatRadioModule,
    MatCardModule,
    MatTabsModule,
    MatProgressBarModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    LazyLoadImageModule,
    TranslateModule,
    FilterPipe,
    CurrencySpacePipe,
    ThemeSourcePipe,
    TopBarComponent,
    TippingFormComponent,
    VoucherFormComponent,
    PaymentOptionsSheetComponent,
    LoaderOverlayComponent,
    CommentSheetComponent,
    CartLineItemComponent,
    ModifierComponent,
    OrderListComponent,
    ComboGuideBlockComponent,
    ItemComponent,
    ItemVariantsSheetComponent,
  ],
  providers: [ThemeSourcePipe]
})
export class SharedModule { }
